var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<a class=\"btn btn-block btn-primary btn-sm m-b-1 continue-shopping-btn\" ui-sref=\"shop.multi-view\"><i class=\"fa fa-tags fa-lg\"></i>&nbsp; Continue Shopping</a>";
var id1="continue-shopping.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;